export default __webpack_public_path__ + "static/media/logo.8bc7cd76.png";